import type { LocalStore } from './types';
import { logger } from '../logger/Logger';

class LocalStoreImpl implements LocalStore {
  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return null;
      return JSON.parse(raw) as T;
    } catch (err) {
      logger.warn('localStore.get-failed', { key, err: String(err) });
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      logger.warn('localStore.set-failed', { key, err: String(err) });
    }
  }

  delete(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      logger.warn('localStore.delete-failed', { key, err: String(err) });
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch (err) {
      logger.warn('localStore.clear-failed', { err: String(err) });
    }
  }
}

let _instance: LocalStore | null = null;

export function getLocalStore(): LocalStore {
  if (!_instance) _instance = new LocalStoreImpl();
  return _instance;
}

export function setLocalStoreForTests(impl: LocalStore): void {
  _instance = impl;
}

export function resetLocalStoreForTests(): void {
  _instance = null;
}
